import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Cancel, CheckCircle } from '@material-ui/icons'
import { theme, colors } from '../../../../../theme/Global'

export const CenterText = styled.div`
  text-align: center;
`

export const StyledGreenIcon = styled(CheckCircle)`
    color: ${colors.green}
    display: inline-block;
`

export const StyledRedIcon = styled(Cancel)`
    color: ${colors.govDocsRed};
    display: inline-block;
`

export const StyledLink = styled(Link)`
  color: ${theme.colors.blueText};
  cursor: pointer;
  font-weight: 600;
  && {
    text-decoration: none;
  }
`

export const StyledText = styled.div`
  color: ${theme.colors.text};
  cursor: default;
  font-weight: 600;
`
